const MasterData = {
  tubular: {
    name: "Tubular Motors",
    subCategories: [
      {
        id: "ac",
        name: "AC Tubular Motor",
         img: "/product-images/AM28/dc.jpg",
        
        list: [
          {
            id: "am28",
            name: "AM28 AC Tubular Motor",
            img: "/product-images/AM28/dc.jpg",
            description:
              "Medium-duty motor for home or office blinds, offering reliable operation and compact design.",
            variants: [
              {
                id: "AM28",
                name: "AM28 AC Tubular Motor",
                img: "/product-images/AM28/dc.jpg",
                 images: [
                      "/product-images/AM28/1.jpg",
                      "/product-images/AM28/2.jpg",
                     
                    ],
                description:
                  "Electronic Limit Radio AC Tubular Motor with advanced functions.",

                features: [
                  "No over-heat issue: Suitable for super light blinds",
                  "Ultra-quiet design: DC motor built-in ensures quiet rolling",
                  "Bi-directional feedback",
                  "Stroke memory function",
                  "Motor direction is reversible",
                  "Soft start and stop",
                  "Jog and continuous rolling adjustment",
                ],
                imgs: [
                       "/product-images/AM28/AM28 AC MOTOR_page-0001.jpg",
                ],
                
              },
            ],
          },
          {
            id: "AM35",
            name: "AM35 AC Tubular Motor",
            img: "/product-images/AM28/am35.jpg",
            description:
              "Compact and quiet motor with multiple control options, ideal for blinds and shutters automation.",

            variants: [
              {
                id: "am35-6-28-q",
                model: "AM35-6/28-Q",
                name: "AM35-6/28-Q Standard AC Tubular Motor",
                description:
                  "Reliable standard AC tubular motor for blinds and shutters.",
                img: "/product-images/AM35_img.jpeg",
                imgs: [
                  "/product-images/AM28/AM-35-6-28-Q.jpg",
                ],
                // specs: [
                //   {
                //     model: "am35-6-28-q",
                //     torque: "6Nm",
                //     speed: "28rpm",
                //     diameter: "35mm",
                //     voltage: "230V",
                //     frequency: "50Hz",
                //     power: "121W",
                //     current: " 0.53A",
                //     ip: "IP44",
                //     control: " Manual Switch",
                //   },
                // ],
                // features: [
                //   "Compact 35mm size for tight spaces",
                //   "Stable torque with smooth rotation",
                //   "Durable copper winding",
                //   "Low noise operation",
                // ],
                // functions: [
                //   "Suitable for roller blinds",
                //   "Works with manual wall switch",
                //   "For small to medium residential blinds",
                // ],
              },
              {
                id: "am35-6-28-e",
                model: "AM35-6/28-E",
                name: "AM35-6/28-E Remote Control AC Tubular Motor",
                description: "Remote controlled tubular motor for easy automation.",
                img: "/product-images/AM35_img.jpeg",

                // features: [
                //   "Built-in RF remote control",
                //   "Plug-and-play installation",
                //   "Stable torque with reliable motor winding",
                //   "Supports multiple remotes",
                // ],
                 imgs: [
                       "/product-images/AM28/AM-35-6-28-E_page-0001 (1).1.jpg",
                ],
                // functions: [
                //   "Remote operation for blinds/shutters",
                //   "Easy integration in smart home",
                //   "User-friendly for elderly and offices",
                // ],
                // specs: [
                //   {
                //     model: "am35-6-28-e",
                //     torque: "6Nm",
                //     speed: "28rpm",
                //     diameter: "35mm",
                //     voltage: "230V",
                //     frequency: "50Hz",
                //     power: "121W",
                //     current: "0.53A",
                //     ip: "IP44",
                //     control: "Remote",
                //   },
                // ],
              },
              {
                id: "am35-6-28-mel-pw",
                model: "AM35-6/28-MEL-PW",
                name: "AM35-6/28-MEL-PW Tuya App Support Electronic Limit Tubular Motor",
                description:
                  "Smart tubular motor with Tuya app support and electronic limit system.",
                img: "/product-images/AM35_img.jpeg",
                    imgs: [
                       "/product-images/AM28/AM35 PW .jpg",
                ],
                // specs: [
                //   {
                //     model: "am35-6-28-mel-pw",
                //     torque: "6Nm",
                //     speed: "28rpm",
                //     diameter: "35mm",
                //     voltage: "230V",
                //     frequency: "50Hz",
                //     power: "121W",
                //     current: "0.53A",
                //     ip: "IP44",
                //     control: "Tuya App / Remote",
                //   },
                // ],
                // features: [
                //   "Electronic limit setting for precision",
                //   "Smart control via Tuya App",
                //   "WiFi + RF dual control",
                //   "Voice control compatible (Alexa, Google)",
                // ],
                // functions: [
                //   "Operate blinds via mobile app",
                //   "Schedule and timer functions",
                //   "Hands-free smart home integration",
                // ],
              },
              {
                id: "am35-6-28-mel-2g",
                model: "AM35-6/28-MEL-ZG",
                name: "AM35-6/28-MEL-ZG Electronic Limit Zero Gap Tubular Motor",
                description:
                  "Zero-gap electronic limit motor for smooth and precise operation.",
                img: "/product-images/AM35_img.jpeg",
                imgs:[
                  "/product-images/AM28/ZERO GAP_1.jpg",
                  "/product-images/AM28/ZERO GAP_2.jpg"
                ]
                // specs: [
                //   {
                //     model: "am35-6-28-mel-2g",
                //     torque: "6Nm",
                //     speed: "28rpm",
                //     diameter: "35mm",
                //     voltage: "230V",
                //     frequency: "50Hz",
                //     power: "121W",
                //     current: "0.53A",
                //     ip: "IP44",
                //     control: "Electronic Limit",
                //   },
                // ],
                // features: [
                //   "Zero gap precision stop",
                //   "Long life cycle electronic control",
                //   "Stable and quiet operation",
                //   "Energy efficient motor",
                // ],
                // functions: [
                //   "For precision blinds/shutter systems",
                //   "Perfect alignment of blinds",
                //   "Used in high-end residential and offices",
                // ],
              },
              {
                id: "am35-10-17",
                model: "AM35-10/17",
                name: "AM35-10/17 Standard AC Tubular Motor",
                description: "Standard AC motor with stronger torque for medium blinds.",
                img: "/product-images/AM35_img.jpeg",
                imgs:[
                  "/product-images/AM28/AM35-10-17_1.jpg"
                ]
                // specs: [
                //   {
                //     model: "am35-10-17",
                //     torque: "10Nm",
                //     speed: "17rpm",
                //     diameter: "35mm",
                //     voltage: "230V",
                //     frequency: "50Hz",
                //     power: "143W",
                //     current: "0.65A",
                //     ip: "IP44",
                //     control: "Manual Switch",
                //   },
                // ],
                // features: [
                //   "Higher torque for larger blinds",
                //   "Durable mechanical design",
                //   "Stable and quiet rotation",
                //   "Reliable for continuous use",
                // ],
                // functions: [
                //   "For medium to large roller blinds",
                //   "Curtains and light shutters",
                //   "Manual switch control",
                // ],
              },
              {
                id: "am35-10-17-E",
                model: "AM35-10/17-E",
                name: "AM35-10/17-E Remote Control AC Tubular Motor",
                description:
                  "Remote controlled motor with higher torque for bigger blinds.",
                img: "/product-images/AM35_img.jpeg",
                  imgs:[
                  "/product-images/AM28/AM35-10-17_1s.jpg"
                  
                ]
               
              },
            ],
          },
          {
            id: "am45",
            name: "AM45 AC Tubular Motor",
            img: "/product-images/AM28/am45.jpg",
            description:
              "Medium-sized motor with integrated radio control, great for curtains and blinds automation.",
            variants: [
              {
                id: "AM45-20-17",
                name: "AM45-20/17 Standard AC Tubular Motor",
                description: "Standard AC tubular motor, reliable and durable.",
                img: "/product-images/AM35-45.jpg",
                imgs:[
                  // "/product-images/AM28/1.0.jpg",
                  // "/product-images/AM28/1.1.jpg"
                  "/product-images/AM28/3.0.jpg"
                ]

       
      },
      {
                id: "AM45-20-17-E",
                name: "AM45-20/17-E Remote Control AC Tubular Motor",
                description: "Remote controlled motor for automation convenience.",
                img: "/product-images/AM35-45.jpg",
                 imgs:[
                  "/product-images/AM28/2.0.jpg",
                  "/product-images/AM28/2.1.jpg"
                ]
        // features: [
        //       "Quite design, lower to 45dB;",
        //       "Repeat positioning accuracy is as low as 2 degrees;",
        //       "Max. limit circle is 55 circles:",
        //       "Double breaking design with patent;",
        //       "Built-in receiver, simpler installation and stable performance;",
        //       "High impact resistant relay, industrial-grade CPU, Working temperature-40°C~+85°C;",
        //       "SMT assembly, damp-proof on surface:",
        //       "Built-in superheterodyne receiving module, long control distance, strong anti-interference ability, receiving sensitivity-110dBm.",
        // ],
        // functions: [
      
        // ],
        //   specs: 
        //   {
        //     voltage: "AC 230V",
        //     power: "120 W",
        //     torque: "20 Nm",
        //     speed: "17 RPM",
        //     tube: "45 mm",
        //     ip: "IP44",
        //    frequency: "433.92 MHz"
        //   }
              },
              {
                id: "AM45-20-30",
                name: "AM45-20/30 Standard AC Tubular Motor",
                description: "Standard motor with increased torque for larger blinds.",
                img: "/product-images/AM35-45.jpg",
                 imgs:[
                  //  "/product-images/AM28/1.0.jpg",
                  // "/product-images/AM28/1.1.jpg"
                  "/product-images/AM28/3.0.jpg"
                  
                ]
          //        features: [
          //   "Quiet design, lower to 45dB",
          //   "Repeat positioning accuracy is as low as 2 degrees",
          //   "Max. limit circle is 65 circles",
          //   "Double braking design with patent"
          // ],

          // functions: [
          //   "RF remote control (with receiver)",
          //   "Wall switch control",
          //   "Smart home integration (optional)"
          // ],

          // specs: {

          //   model: "AM45-20-30",
          //   torque: "20Nm",
          //   rpm: "30",
          //   diameter: "45mm",
          //   tube: "550mm",
          //   voltage: "230V",
          //   power: "200W",
          
          //   ip: "IP44",
          //   control: "Switch"
          // }
              },
              {
                id: "AM45-20-30-E",
                name: "AM45-20/30-E Remote Control AC Tubular Motor",
                description: "Remote control support for smooth operation.",
                img: "/product-images/AM35-45.jpg",
                imgs:[
                  "/product-images/AM28/2.0.jpg",
                  "/product-images/AM28/2.1.jpg"
                ]
          //        features: [
          //   "Quiet design, lower to 45dB",
          //   "Repeat positioning accuracy is as low as 2 degrees",
          //   "Max. limit circle is 65 circles",
          //   "Double braking design with patent",
          //   "Built-in receiver, simpler installation and stable performance",
          //   "High impact resistant relay, industrial-grade CPU, working temperature -40℃ ~ +85℃",
          //   "SMT assembly, damp-proof on surface",
          //   "Built-in superheterodyne receiving module, long control distance, strong anti-interference ability"
          // ],

          // functions: [
          //   "RF remote control",
          //   "Wall switch control",
          //   "Smart home integration (optional)"
          // ],

          // specs: {
          //    model: "am45-20-30-e",
          //   torque: "20Nm",
          //   rpm: "30rpm",
          //   diameter: "45mm",
          //   tube: "580mm",
          //   voltage: "230V",
          //   power: "250W",
          //   current: "1.09A",
          //   ip: "IP44",
          //   control: "Built-in Receiver"
          // }
              },
              {
                id: "AM45-20-17-ZS",
                name: "AM45-20/17-ZS Electronic Limit Exterior Zip Blinds Tubular Motor",
                description:
                  "Special motor for exterior zip blinds with electronic limit.",
                img: "/product-images/AM35-45.jpg",
                 imgs:[
                  "/product-images/AM28/4.0.jpg"
                  
                ]
          //        features: [
          //   "Obstacle detection: stops the shutter from coming down automatically when obstacles are encountered to protect belongings",
          //   "Available for automation of zip screen / zip blinds",
          //   "Recall brake final stop positions: automatically memorizes the two brake positions, open fully cycle to maintain best end stops all the time",
          //   "Flexible limit setting mode: automatic and manual options available"
          // ],

          // functions: [
          //   "Switch control",
          //   "Obstacle detection",
          //   "Zip screen application"
          // ],

          // specs: {
          //   torque: "20Nm",
          //   rpm: "17rpm",
          //   diameter: "45mm",
          //   tube: "522mm",
          //   voltage: "230V",
          //   power: "170W",
          //   current: "0.73A",
          //   ip: "IP44",
          //   control: "Switch"
          // }
              },
              {
                id: "AM45-20-17-ZS-E",
                name: "AM45-20/17-ZS-E Electronic Limit Exterior Zip Blinds Tubular Motor",
                description: "Advanced variant with electronic limit for zip blinds.",
                img: "/product-images/AM35-45.jpg",

                 imgs:[
                   "/product-images/AM28/4.0.jpg"
                  
                ]
        //          features: [
        //   "Obstacle detection: stops blinds from coming down automatically when obstacles are encountered.",
        //   "Flexible limit setting mode: Auto or manual limit setting.",
        //   "Recall brake final stop positions: memorizes end-stop positions and keeps them accurate.",
        //   "Electronic limit system for smooth operation."
        // ],

        // functions: [
        //   "RF remote control",
        //   "App control (WiFi / Tuya)",
        //   "Voice control",
        //   "Timer control",
        //   "Wind sensor compatible",
        //   "Sunlight sensor compatible"
        // ],

        // specs: {
        //    model: "am45-20-17-zs-e",
        //   torque: "20Nm",
        //   rpm: "17rpm",
        //   diameter: "45mm",
        //   tube: "502mm",
        //   voltage: "230V",
        //   power: "170W",
        //   current: "0.7A",
        //   ip: "IP44",
        //   control: "RF + WiFi + App + Sensor"
        // }

        },

        {
          id: "AM45-20-17-ZS-E-W",
          name: "AM45-20/17-ZS-E-W  Electronic Limit Exterior Zip Blinds Tubular Motor ",
          description: "Heavy-duty motor variant for larger applications.",
          img: "/product-images/AM35-45.jpg",
           imgs:[
                  "/product-images/AM28/4.0.jpg"
                  
                ]
          
              },


              {
                id: "AM45-50-12",
                name: "AM45-50/12 Standard AC Tubular Motor",
                description: "Heavy-duty motor variant for larger applications.",
                img: "/product-images/AM35-45.jpg",
                 imgs:[
                  // "/product-images/AM28/3.0.jpg"
                     "/product-images/AM28/1.0.jpg",
                  "/product-images/AM28/1.1.jpg"
                  
                ]
          //        features: [
          //   "Heavy-duty motor designed for larger blinds and shutters.",
          //   "Quiet design, lower than 45dB.",
          //   "Reliable performance with strong torque output.",
          //   "Double braking design with patent."
          // ],

          // functions: [
          //   "Switch control",
          //   "Remote control (with receiver)",
          //   "Smart home integration (optional)"
          // ],

          // specs: {
          //    model: "am45-50-12",
          //   torque: "50Nm",
          //   rpm: "12rpm",
          //   diameter: "45mm",
          //   tube: "492mm",
          //   voltage: "230V",
          //   power: "300W",
          //   current: "1.5A",
          //   ip: "IP44",
          //   control: "Switch"
          // }
              },
              {
                id: "AM45-50-12-ME",
                name: "AM45-50/12-ME Built-in Radio Manual Operated Tubular Motor For Awning",
                description:
                  "Manual operated tubular motor with built-in radio, designed for awnings.",
                img: "/product-images/AM45 50-12.jpg",
                imgs:[
                  "/product-images/AM28/5.0.jpg",
                   "/product-images/AM28/5.1.jpg",
                    "/product-images/AM28/5.2.jpg",
                     "/product-images/AM28/5.3.jpg"
                ]
          
              },
            ],
          },



    {
            id: "am60",
            name: "AM60 AC Tubular Motor",
            img: "/product-images/AM28/am60.jpg",
            description:
              "Heavy-duty motor designed for large blinds, offering smooth and powerful operation.",
            variants: [
              {
                id: "AM60-80-12-ME",
                name: "AM60-80/12-ME Built-In Radio Manual Operated Tubular Motor ",
                desc: "AC tubular motor, reliable and durable.",
                description :" AM60 Built In Radio Manual Operated Tubular Motor is mainly applied for medium and small size of roller shutters,  rolling doors, awnings and big size screens. It can be manually operated when electricity is off.",
                img: "/product-images/AM60_img.jpeg",

                features: [
                "Quiet running, lower to 45db;",
                "Built-in superheterodyne receiving module, long control distance,  High anti-interference, receive sensibility -110dBm",
                "Repeat positioning accuracy is as low as 2 degrees",
                "Worm gear speed reducer makes it easier to move by hand",
                "Built-in receiver, simpler installation and stable performance",
                "Accurate SMT assembly, damp-proof treatment on surface;  High impact resistant relay, industrial-grade CPU, working temperature -40~+85℃",
                "Double breaking design with patent."
              ],

              imgs: [
            
                 "/product-images/AM28/6.1.jpg",
                 "/product-images/AM28/6.2.jpg",
                 "/product-images/AM28/6.3.jpg",
                 "/product-images/AM28/6.4.jpg",
                 "/product-images/AM28/6.5.jpg",
                 "/product-images/AM28/6.6.jpg",
              ]

              },
              {
                id: "AM60-100-12-ME",
                name: "AM60-100/12-ME Built-In Radio Manual Operated Tubular Motor",
                desc: "Remote controlled motor for automation convenience.",
                description :" AM60 Built In Radio Manual Operated Tubular Motor is mainly applied for medium and small size of roller shutters,  rolling doors, awnings and big size screens. It can be manually operated when electricity is off.",
                img: "/product-images/AM60_img.jpeg",
              features: [
                "Quiet running, lower to 45db;",
                "Built-in superheterodyne receiving module, long control distance,  High anti-interference, receive sensibility -110dBm",
                "Repeat positioning accuracy is as low as 2 degrees",
                "Worm gear speed reducer makes it easier to move by hand",
                "Built-in receiver, simpler installation and stable performance",
                "Accurate SMT assembly, damp-proof treatment on surface;  High impact resistant relay, industrial-grade CPU, working temperature -40~+85℃",
                "Double breaking design with patent."
              ],

              imgs: [
            
                 "/product-images/AM28/6.1.jpg",
                 "/product-images/AM28/6.2.jpg",
                 "/product-images/AM28/6.3.jpg",
                 "/product-images/AM28/6.4.jpg",
                 "/product-images/AM28/6.5.jpg",
                 "/product-images/AM28/6.6.jpg",
              ]
              
              },
              {
                id: "AM60-120-9-ME",
                name: "AM60-120/9-ME Built-In Radio Manual Operated Tubular Motor",
                desc: " Motor with increased torque for larger blinds.",
                description :" AM60 Built In Radio Manual Operated Tubular Motor is mainly applied for medium and small size of roller shutters,  rolling doors, awnings and big size screens. It can be manually operated when electricity is off.",
                img: "/product-images/AM60_img.jpeg",
               features: [
                "Quiet running, lower to 45db;",
                "Built-in superheterodyne receiving module, long control distance,  High anti-interference, receive sensibility -110dBm",
                "Repeat positioning accuracy is as low as 2 degrees",
                "Worm gear speed reducer makes it easier to move by hand",
                "Built-in receiver, simpler installation and stable performance",
                "Accurate SMT assembly, damp-proof treatment on surface;  High impact resistant relay, industrial-grade CPU, working temperature -40~+85℃",
                "Double breaking design with patent."
              ],

              imgs: [
            
                 "/product-images/AM28/6.1.jpg",
                 "/product-images/AM28/6.2.jpg",
                 "/product-images/AM28/6.3.jpg",
                 "/product-images/AM28/6.4.jpg",
                 "/product-images/AM28/6.5.jpg",
                 "/product-images/AM28/6.6.jpg",
              ]
              },
              {
                id: "AM60-140-9-ME",
                name: "AM60-140/9-ME Built-In Radio Manual Operated Tubular Motor",
                description :" AM60 Built In Radio Manual Operated Tubular Motor is mainly applied for medium and small size of roller shutters,  rolling doors, awnings and big size screens. It can be manually operated when electricity is off.",
                desc: "Remote control support for smooth operation.",
                img: "/product-images/AM60_img.jpeg",

              features: [
                "Quiet running, lower to 45db;",
                "Built-in superheterodyne receiving module, long control distance,  High anti-interference, receive sensibility -110dBm",
                "Repeat positioning accuracy is as low as 2 degrees",
                "Worm gear speed reducer makes it easier to move by hand",
                "Built-in receiver, simpler installation and stable performance",
                "Accurate SMT assembly, damp-proof treatment on surface;  High impact resistant relay, industrial-grade CPU, working temperature -40~+85℃",
                "Double breaking design with patent."
              ],

              imgs: [
            
                 "/product-images/AM28/6.1.jpg",
                 "/product-images/AM28/6.2.jpg",
                 "/product-images/AM28/6.3.jpg",
                 "/product-images/AM28/6.4.jpg",
                 "/product-images/AM28/6.5.jpg",
                 "/product-images/AM28/6.6.jpg",
              ]
              },
            ],
          },
        ],
      },
      {
        id: "dc",
        name: "DC Tubular Motor",
        img: "/product-images/AM28/dc.jpg",
        list: [
          {
            id: "am25",
            name: "AM25 Series DC Tubular Motor",
            img: "/product-images/DC/am25.jpg",
            description:
              "Perfect for electric rolling blinds with efficient lithium battery system.",
            variants: [
              {
                id: "AM25-1-2-30-es-e",
                model: "AM25-1.2/30-ES-E",
                name: "AM25-1.2/30-ES-E Built-In Lithium Battery DC Tubular Motor",
                img: "/product-images/DC/am25.jpg",
                description: "AM25 Built-in Lithium Battery motors are mainly used in indoor sunshade roller blinds ",
                 imgs:[
                  "/product-images/DC/AM25 page001.jpg",
                ],
                features: [
                  "Rechargeable by lithium battery, battery pole or solar panel",
                  "Fully charged lithium battery will support one up and down operation each day for 6 months.",
                  "Quiet running with noise level below 40dB",
                  "Industrial level electronic components ensure good performance from interference working environment",
                  "Auto correct limit after power off",
                  "To set limit by remote, simplify your operation",
                  "Stop by block to protect object and user from damage",
                  "Energy saving design with patent, powered by battery pole of solar panel",
                  "Control board is sealed by plastic box, safe and stable",
                ],
                
              },
            ],
          },
          {
            id: "am28",
            name: "AM28 Series DC Tubular Motor",
            img: "/product-images/DC/am28.jpg",
            description:
              "Lightweight motor with coreless design for smooth and quiet operation.",
            variants: [
              {
                id: "AM28-1-8-30-es-e",
                model: "AM28-1.8/30-ES-E",
                name: "AM28-1.8/30-ES-E Coreless Built-In Lithium Battery DC Tubular Motor",
                img: "/product-images/DC/am28.jpg",
                description:
                  "Coreless DC tubular motor with lithium battery for smooth automation.",
                features: [
                  "Power saving design with patent, build in 7.4V/3000mA lithium battery supports to charged by charger and solar panel;",
                  "Can be set 6 limits (Up/down and 4 middle limits);",
                  "Auto correct limit after power off;",
                  "Sensor short circuit, open circuit protection;",
                  "The sealed box structure to protect the inside control part, higher security:",
                  "Change the motor running modes as you want;",
                  "Coreless DC motor running ultra-quiet and long life (over 2000 hours).",
                ],
                 imgs:[
                  "/product-images/DC/AM28 page001.jpg",
                  "/product-images/DC/AM28 page002.jpg",
                ],
               
              },
            ],
          },
        ],
      },
    ],
  },
  curtain: {
    name: "Curtain Motors",
    subCategories: [
      {
        id: "default",
        name: "Curtain Motor",
        list: [
           {
            id: "LM100",
            name: "LM100 AC Input Curtain Motor",
            description:
              "High-performance AC curtain motor for large-scale applications.",
            img: "/product-images/CurtainMotors/LM100.jpg",
           
            imgs:[
              "/product-images/CurtainMotors/LM100 page001.jpg",
              "/product-images/CurtainMotors/LM100 page002.jpg",

            ],
            
          },
          {
            id: "AM68",
            name: "AM68 AC Input Curtain Motor",
            description:
              "Reliable AC curtain motor for residential and commercial applications.",
            img: "/product-images/CurtainMotors/AM68.jpg",
                imgs:[
              "/product-images/CurtainMotors/AM68 page001.jpg",
            ],
          },
          {
            id: "AM75",
            name: "AM75 Strong AC Quiet Curtain Motor",
            description:
              "Powerful and ultra-quiet motor, suitable for large and heavy curtains.",
            img: "/product-images/CurtainMotors/AM75.jpg",
               imgs:[
              "/product-images/CurtainMotors/AM75 page001.jpg",
            ],
          },
          {
            id: "AM75-wifi",
            name: "AM75 Strong AC Quiet Smart Wi-Fi Curtain Motor",
            description:
              "Smart Wi-Fi enabled curtain motor with app and voice assistant support.",
             img: "/product-images/CurtainMotors/AM75.jpg",
               imgs:[
              "/product-images/CurtainMotors/AM75 page001.jpg",
            ],
          },
          {
            id: "AM93",
            name: "AM93 AC Input Curtain Motor",
            description: "Durable curtain motor with robust AC input design.",
            img: "/new-product/AM93.png",
                imgs:[
              "/product-images/CurtainMotors/AM93 page001.jpg",
            ],
          },
          {
            id: "AM95",
            name: "AM95 AC Input Maglev Curtain Motor",
            description:
              "Curtain motor with maglev technology for smoother operation and higher efficiency.",
            img: "/product-images/CurtainMotors/AM95.jpg",
               imgs:[
              "/product-images/CurtainMotors/AM95 page001.jpg",
            ],
            // features: [
            //   "Maglev technology for smooth operation",
            //   "Energy efficient design",
            // ],
          
            // functions: ["Switch control", "Remote control"],
            // specs: {
            //   model: "am95",
            //   torque: "-",
            //   rpm: "-",
            //   voltage: "230V",
            //   power: "-",
            //   current: "-",
            //   ip: "IP44",
            //   control: "Switch / Remote",
            // },
          },
          {
            id: "AM98",
            name: "AM98 AC Input Maglev Curtain Motor",
            description:
              "Advanced maglev motor designed for premium and luxury curtain installations.",
            img: "/product-images/CurtainMotors/AM98.jpg",

              imgs:[
              "/product-images/CurtainMotors/AM98 page0001.jpg",
            ],


           
          },
         
        ],
      },
    ],
  },
  venetian: {
    name: "Venetian Blinds",
    subCategories: [
      {
        id: "default",
        name: "Venetian Blinds Motor",
        list: [
          {
            id: "AM24",
            name: "AM24 DC Input Electronic Limit Venetian Blinds Motor",
            description: "Electronic Limit Venetian Blinds Motor",
            img: "/product-images/CurtainMotors/venetian v1 s.jpg",
           imgs:[
                "/product-images/CurtainMotors/AM24 page001.jpg",
              ],
          },
          {
            id: "AM24-SKYLIGHT-MOTOR",
            name: "AM24 DC Input Electronic Limit Motor (Special For Skylight Blinds)",
            description:"DC-powered tubular motor equipped with electronic limit, designed for skylight blinds.",
            img: "/product-images/CurtainMotors/v3.jpg",
            imgs:[
              "/product-images/CurtainMotors/AM24 page002.jpg",
            ],
          
          },
          {
            id: "AM24-TDBU-MOTOR",
            name: "AM24 DC Input Electronic Limit TDBU Blinds Motor",
            description:
              "Electronic Venetian Blind Drive Motor, ideal for TDBU (Top-Down Bottom-Up) blinds.",
            img: "/product-images/CurtainMotors/v3.jpg",
             imgs:[
              "/product-images/CurtainMotors/TDBU page001.jpg",
            ],
            // features: [
            //   "Three limits(up/middle/down) can be set, also can save the setting after power off:",
            //   "Hall sensor for High precise limits;",
            //   "Supports two operating modes of dot mode and continuous mode;",
            //   "Location sensor provides short circuit protection and stop protection when blocked;",
            //   "Easy to change the motor direction;",
            //   "Super heterodyne receiving module, sensitivity up to-110dBm.",
            // ],
            // functions: ["Remote control", "App integration (optional)"],
            // specs: {
            //   model: "am24tdbu",
            //   torque: "0.6Nm",
            //   rpm: "34rpm",
            //   diameter: "24mm",
            //   voltage: "24V DC",
            //   power: "20W",
            //   current: "400mA",
            //   ip: "IP42",
            //   control: "Electronic Limit",
            // },
          },
        ],
      },
    ],
  },
  control: {
    name: "Control System",
    subCategories: [
      {
        id: "RemoteController",
        name: "Remote Controllers",
        img: "/controlsystem/transmitter.jpg",
        list: [
          {
            id: "AC123",
            name: "AC123 Single/Dual/Six/Sixteen Channel Handheld Wireless Smart Transmitter",
            description:
              "AC123 handheld transmitter with multiple channel options. ",
            img: "/controlsystem/t1.jpg",
            brand: "A-OK",
            itemNo: "AM123",
            color: "Black & White",
            leadTime: "2-3 Months (A-OK standard)",
            order: "100 pcs",
            warranty: "Up to 2 years",
            certificate: "CE/CB/TUV/C-TICK/R&TTE/FCC/RoHS/C-UL-US/C-TUV-US",
            imgs:[
                  "/product-images/remote-controller/AC123.jpg",
                   "/product-images/remote-controller/AC123-1.png",
                ],
            features: [
              "Simple trend design, luxurious piano lacquer surface treatment,  honorable and elegant",
              "Acrylic panel surface, anti-scratch",
              "CR2032 button battery, easy to replace",
              "Ultra-long standby time,batteries last(2-3 years)",
              "ZigBee bi-directional communication",
            ],
           
            
          },

          {
            id: "AC133",
            name: "AC133 Wireless Wall-Mounted 01 and 05 Channels Emitter ",
            desc:"AC133 series products adopts a wall-mounted design. ",
            description:"AC133 series products adopts a wall-mounted design. ",
           img: "/controlsystem/t2.jpg",
            brand: "A-OK",
            itemNo: "AM133",
            color: "Black & White",
            leadTime: "2-3 Months (A-OK standard)",
            order: "100 pcs",
            warranty: "Up to 2 years",
            certificate: "CE/CB/TUV/C-TICK/R&TTE/FCC/RoHS/C-UL-US/C-TUV-US",
            features: [
              ".Classic black and white color combination, simple and fancy",
              "Housing surface with piano lacquer craft",
              "Precision SMT process with moisture-proof treatment",
              "3With 3M adhesive tape on the back, it can be fixed at any  position on the wall at will, without wiring, to avoid damage to the wall",
              "Compatible with any A-OK receiver of the  same frequency",
            ],
            imgs:[
                "/product-images/remote-controller/AC133.jpg",
                "/product-images/remote-controller/2.3.png",
           
            ],
          },
          {
            id: "AC153",
            name: "AC153 Smart Hand-held 06 Channel Emitter with Timer",
            description:
              "AC153 curtain transmitter pursues simplicity and fashion, with sliver metal body.",
           img: "/controlsystem/t4.jpg",
            brand: "A-OK",
            itemNo: "AC153",
            color: "white",
            leadTime: "2-3 Months (A-OK standard)",
            order: "100 pcs",
            warranty: "Up to 2 years",
            certificate: "CE/CB/TUV/C-TICK/R&TTE/FCC/RoHS/C-UL-US/C-TUV-US",
            features: [
              "Accurate and easy slat tilt angle control",
              "Multi-channel for group/subgroup control",
              "No fear of 16KV static electricity, built-in ESD protection circuit",
              "Perfection design for comfortable hold",
              "Large capacity battery, ultra-low power consumptions",
              "Wear-resistant and non-slip, spun carbon ﬁber texture back shell design",
            ],
             imgs:[
                "/product-images/AC153.jpg",
                
           
            ],
          },



          
          {
            id: "AC140",
            name: "AC140 Hand-held 02 and 16 channels transmitter with touch buttons",
            description:
              "AC140 Smart Touch button curtain emitter with 02 and 16 channel.",
           img: "/controlsystem/t5.jpg",
            brand: "A-OK",
            itemNo: "AC140",
            color: "white",
            leadTime: "2-3 Months (A-OK standard)",
            order: "100 pcs",
            warranty: "Up to 2 years",
            certificate: "CE/CB/TUV/C-TICK/R&TTE/FCC/RoHS/C-UL-US/C-TUV-US",
            features: [
              "With capacitive touchpad, good for anti-interference and stability",
              "RF consumption at 10mW, work with all A-OK receiver",
              "Energy saving design, CR2450 power for 2years use",
              
            ],
             imgs:[
                  "/product-images/AC140-P.jpg",
                
            ],
          },
          {
            id: "AC152",
            name: "AC152 Hand-held 06 Channels Emitter ",
            description:"AC152 Scroll wheel multi channel remote control.",
            img: "/controlsystem/t3.jpg",
            brand: "A-OK",
            itemNo: "AC152",
            color: "Black",
            leadTime: "2-3 Months (A-OK standard)",
            order: "100 pcs",
            warranty: "Up to 2 years",
            certificate: "CE/CB/TUV/C-TICK/R&TTE/FCC/RoHS/C-UL-US/C-TUV-US",
             imgs:[
                "/product-images/AC152.jpg",
                
           
            ],
            features: [
              "Multiple channel options (1/2/6/16)",
              "Compact and user-friendly design",
              "Smooth wireless control",
              "Compatible with all curtain/blinds motors",
              "Long-range stable signal",
            ],
            // functions: [
            //   "Single channel",
            //   "Dual channel",
            //   "Six channel",
            //   "Sixteen channel",
            // ],
            // specs: {
            //   model : "ac140",
            //   channels: "1 / 2 / 6 / 16",
            //   control: "RF Wireless",
            //   usage: "Curtains / Blinds / Shades",
            // },
          },
        ],
      },
      {
        id: "receiver",
        name: "Radio Receiver",
        img: "/controlsystem/receiver.jpg",
        list: [
          {
            id: "RR433",
            name: "Universal 433.92mhz Radio Receiver RF Remote",
            description:
              "Receives RF signals and enables remote control compatibility with various curtain and blinds motors.",
            img: "/controlsystem/r1.jpg",
            imgs:[
                  "/product-images/RR433.1.jpg",
                  "/product-images/RR433.2.jpg",
            ],
            features: [   
            "Simple and fashion design, suitable for various decoration style",
            "Plastic covers adopt fire + UV protect material",
            "Sliding casing design, easy to operate",
            "With sides switches and external switch connection",
            "Remote control and network control via RS232/485 interface",
            "Changing direction on switch and remote, support for dot move and continuous move",
            "With 12V port for photocell or sensor",
            ]
          },
          {
            id: "AC408",
            name: "AC408-02 Four Routes Wireless AC Group Controller",
            description:
              "Controls up to 4 curtain motors wirelessly, ideal for grouped window treatment automation.",
            img: "/controlsystem/r2.jpg",
              imgs:[
                  "/product-images/408.1.jpg",
                  "/product-images/408.2.jpg",
            ],
            features: [
              "Radio receiver and group controller together;",
              "Connect with 4 motors individual and group;",
              "Low voltage switch can be connected externally;",
              "UV and fire proof ABS plastic material;",
              "Industry level CPU, with temperature -40~+85.",
            ]
          },
          {
            id: "AC227-AC228",
            name: "AC227-01 / AC228-01 Wall Mounted Radio Receiver",
             images: [
                      "/product-images/p2.jpg",
                      "/product-images/p1.jpg",
                     
                    ],
            description:
              "These are wall mounted crystal style single and double channel radio receivers designed to control tubular and curtain motors.",
            img: "/controlsystem/227-01.jpg",
            
              imgs:[
                  "/controlsystem/AC227-01.jpg",
                  "/controlsystem/AC228-01.jpg",
            ],
            features: [
              "Built-in silver print on buttons fancy and fashion",
              "Suitable for the motor power below 50W",
              "Shock proof relay",
              "Remote control and manual control for option",
              
            ]
          },

        




        ],
      },
    ],
  },



  chain: {
    name: "Chain Blind",
    subCategories: [
      {
        id: "Chainblind",
        name: "Chain Blind",
        img: "",
        list: [
          {
            id: "AM43",
            name: "AM43 Smart Control Automatic Chain Blinds Drive Motor",
            description: "Smart home automatic blinds drive roller, support for Bluetooth control, APP control, built-in battery motor, solar charging. Support a variety of manual roller blinds, support timing settings. Easy installation without removing the curtains. ",
            img:"/product-images/AM43/am43.jpg",
            brand: "A-OK",
            itemNo: "AM43",
            color: " White & Custom",
            leadTime: "2-3 Months (A-OK standard)",
            order: "100 pcs",
            warranty: "Up to 2 years",
            certificate: "CE/CB/TUV/C-TICK/R&TTE/FCC/RoHS/C-UL-US/C-TUV-US",
            imgs:[
                  "/product-images/AM43/2.jpg",
                  "/product-images/AM43/4.jpg",
                  "/product-images/AM43/5.jpg",            
                ],
             features: [   
            "Mini size design, casing with fireproof material.",
            "Lithium battery built inside, charged by solar penal or battery  charger, stop by block function.",
            "Bluetooth APP control, working on IOS and Android system.",
            "Adjustable running speed, quiet design, running noise  as low as 40dB.",
            "Bluetooth APP to set limits, timing function will close and open.",
            "Light sensor on solar penal will close or open blinds automatically  according to the light intensity.",
            "Single/group control for optional, soft start and stop function.",
            ],
           
            
          },

         
        



          
          
        ],
      },
      
    ],
  },



};

export default MasterData;
